import { Component, Inject, OnInit } from "@angular/core";
import { TUI_NUMBER_FORMAT, TuiDialogContext } from "@taiga-ui/core";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";
@Component({
  selector: "app-payment-option",
  templateUrl: "./payment-option.component.html",
  styleUrls: ["./payment-option.component.scss"],
  providers: [
    {
      provide: TUI_NUMBER_FORMAT,
      useValue: { decimalSeparator: ".", thousandSeparator: "," },
    },
  ],
})
export class PaymentOptionComponent implements OnInit {
  error = "";
  studentloan: boolean = false;
  selectedOption: string = "no";
  selectedOption1: string = "no";
  selectedOption2: string = "no";
  selectedOption3: string = "no";
  value1: number = 0;
  value2: number = 0;
  value3: number = 0;
  value4: number = 0;
  sumResult: number = 0;
  paymentDropdown: any = [
    { value: "1", label: "5" },
    { value: "2", label: "8" },
    { value: "3", label: "10" },
  ];
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>
  ) {
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.add("payment");
  }

  ngOnInit(): void {}
  sum() {
    if (this.selectedOption === "no") {
      this.value1 = 0;
    }
    if (this.selectedOption1 === "no") {
      this.value2 = 0;
    }
    if (this.selectedOption2 === "no") {
      this.value3 = 0;
    }
    if (this.selectedOption3 === "no") {
      this.value4 = 0;
    }
    this.sumResult =
      Number(this.value1 / 4) +
      Number(this.value2 * 12) +
      Number(this.value3) +
      Number(this.value4);
    return "$" + "" + Math.round(this.sumResult).toLocaleString();
  }
  close() {
    this.context.completeWith("");
    // const dialog = document.querySelector('tui-dialog');
    // dialog.classList.remove('payment');
  }
  savedata() {
    this.context.completeWith(this.sumResult);
  }
  formatValue(num: number) {
    if (num > 5500) {
      // this.error = "Loan contribution can't be greater than total loan amount";
      this.studentloan = true;
      return;
    } else {
      this.studentloan = false;
      return;
    }
  }
}
